import { useState } from 'react';

export interface MenuApi {
  open: (anchorEl: Element) => void;
  close: () => void;
  anchorEl: Element | null;
}

export interface MenuTestDefaults {
  initialAnchorEl?: Element | null;
}

export const useMenu = ({ initialAnchorEl = null }: MenuTestDefaults = {}): MenuApi => {
  const [anchorEl, setAnchorEl] = useState<Element | null>(initialAnchorEl);

  const open = (anchorEl: Element) => setAnchorEl(anchorEl);

  const close = () => setAnchorEl(null);

  return {
    open,
    close,
    anchorEl,
  };
};
